import { notification } from 'antd';
import { useCancelSubscriptionMutation, useFetchSubscriptionQuery } from '../service';
import { useAppDispatch } from '../../useAppDispatch';
import { refreshAccessToken } from '../../store/iam/operations';
import { skipToken } from '@reduxjs/toolkit/query';

export default function useCancelSubscription(skip?: boolean) {
    const dispatch = useAppDispatch();

    const { data: subscription } = useFetchSubscriptionQuery(skip ? skipToken : undefined);
    const [cancelSubscriptionTrigger, { isLoading: isCancellingSubscription }] = useCancelSubscriptionMutation();

    const cancelSubscription = async (reason: string, comment: string) => {
        if (!subscription) {
            notification.error({
                message: 'Error',
                description: 'Something went wrong. Please try again',
            });
            return;
        }

        try {
            await cancelSubscriptionTrigger({ plan_code: subscription.plan_code, reason, comment }).unwrap();
            await dispatch(refreshAccessToken()); // TODO Refactor this after IAM
        } catch (error) {
            notification.error({
                message: 'Error',
                description: 'Cannot cancel subscription. Please try again or contact support!',
            });
        }
    };

    return {
        cancelSubscription,
        isCancellingSubscription,
    };
}
